// extracted by mini-css-extract-plugin
module.exports = {"insightsContainer":"AnJtyWcE","count":"zXzn2FTS","countDisabled":"yvO8CfJf"};